module.exports = __webpack_public_path__ + "img/img_throw_3@3x_v3.c7e0badd.png";